import axiosInstance from "@/api/axiosConfig";

import type { OnboardingProgress } from "../types";

export const OnboardingAPI = {
  async get(): Promise<OnboardingProgress> {
    const { data } = await axiosInstance.get<OnboardingProgress>("/onboarding");
    return data;
  },

  /** The member's onboarding thread, created with its kickoff the first time. */
  async start(): Promise<OnboardingProgress> {
    const { data } = await axiosInstance.post<OnboardingProgress>(
      "/onboarding/start"
    );
    return data;
  },

  async dismiss(): Promise<OnboardingProgress> {
    const { data } = await axiosInstance.post<OnboardingProgress>(
      "/onboarding/dismiss"
    );
    return data;
  },

  async restart(): Promise<OnboardingProgress> {
    const { data } = await axiosInstance.post<OnboardingProgress>(
      "/onboarding/restart"
    );
    return data;
  }
};
